import { render, staticRenderFns } from "./ButtonsToolbar.vue?vue&type=template&id=5684b093&scoped=true"
import script from "./ButtonsToolbar.vue?vue&type=script&lang=js"
export * from "./ButtonsToolbar.vue?vue&type=script&lang=js"
import style0 from "./ButtonsToolbar.vue?vue&type=style&index=0&id=5684b093&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684b093",
  null
  
)

export default component.exports